import WallboardsResources from 'flow/api/wallboards';
import { networkErrorDispatcher } from 'flow/actions/app-actions';
import { getWallboardIdFromWallboardEntitytKey } from 'flow/utils/wallboard-utils';
import Actions from 'flow/actions';
import { HTTPStatusCodes } from 'flow/utils';

export const updateWallboard = (wallboardDTO, wallboardKey) => (dispatch) => {
    const wallboardId = getWallboardIdFromWallboardEntitytKey(wallboardKey);

    return new Promise((resolve, reject) => {
        WallboardsResources.updateWallboard(
            {
                onResult(json) {
                    dispatch(wallboardUpdated(json, wallboardKey));
                    resolve(json);
                },
                onError: (error) => {
                    networkErrorDispatcher(dispatch)(error);
                    reject(error);
                },
                onClientError: (error) => {
                    networkErrorDispatcher(dispatch)(error);
                    reject(error);
                },
            },
            wallboardId,
            wallboardDTO,
        );
    });
};

export const createWallboard = (wallboardDTO) => (dispatch) => {
    return new Promise((resolve, reject) => {
        WallboardsResources.createWallboard(
            {
                onResult(json) {
                    dispatch(wallboardCreated(json));
                    resolve(json);
                },
                onError: (error) => {
                    networkErrorDispatcher(dispatch)(error);
                    reject(error);
                },
                onClientError: (error) => {
                    networkErrorDispatcher(dispatch)(error);
                    reject(error);
                },
            },
            wallboardDTO,
        );
    });
};

export const regenerateWallboard = (wallboardKey) => (dispatch) => {
    const wallboardId = getWallboardIdFromWallboardEntitytKey(wallboardKey);

    return new Promise((resolve, reject) => {
        WallboardsResources.regenerateWallboard(
            {
                onResult(json) {
                    dispatch(wallboardRegenerated(json, wallboardKey));
                    resolve(json);
                },
                onError: (error) => {
                    networkErrorDispatcher(dispatch)(error);
                    reject(error);
                },
                onClientError: (error) => {
                    networkErrorDispatcher(dispatch)(error);
                    reject(error);
                },
            },
            wallboardId,
        );
    });
};

export const fetchWallboards = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        WallboardsResources.getWallboards({
            onResult(json) {
                dispatch(receiveWallboards(json));
                dispatch(setWallboardAccess(true));
                resolve(json);
            },
            onError: (error) => {
                networkErrorDispatcher(dispatch)(error);
                reject(error);
            },
            onClientError: (error) => {
                if (
                    error.status === HTTPStatusCodes.FORBIDDEN_403 ||
                    error.status === HTTPStatusCodes.FORBIDDEN_401
                ) {
                    dispatch(setWallboardAccess(false));
                } else {
                    networkErrorDispatcher(dispatch)(error);
                    reject(error);
                }
            },
        });
    });
};

export const deleteWallboard = (wallboardKey) => (dispatch) => {
    const wallboardId = getWallboardIdFromWallboardEntitytKey(wallboardKey);

    return new Promise((resolve, reject) => {
        WallboardsResources.deleteWallboard(
            {
                onResult() {
                    dispatch(wallboardDeleted(wallboardKey));
                    resolve();
                },
                onError: (error) => {
                    networkErrorDispatcher(dispatch)(error);
                    reject(error);
                },
                onClientError: (error) => {
                    networkErrorDispatcher(dispatch)(error);
                    reject(error);
                },
            },
            wallboardId,
        );
    });
};

const receiveWallboards = (json) => ({
    type: Actions.RESULT_WALLBOARDS,
    data: json,
});

const wallboardCreated = (json) => ({
    type: Actions.RESULT_WALLBOARD_CREATED,
    data: json,
});

const wallboardUpdated = (json, key) => ({
    type: Actions.RESULT_WALLBOARD_UPDATED,
    data: json,
    key: key,
});

const wallboardRegenerated = (json, key) => ({
    type: Actions.RESULT_WALLBOARD_REGENERATED,
    data: json,
    key: key,
});

const wallboardDeleted = (key) => ({
    type: Actions.RESULT_WALLBOARD_DELETED,
    key: key,
});

const setWallboardAccess = (access) => ({
    type: Actions.SET_WALLBOARD_ACCESS,
    access: access,
});
